import PropTypes from 'prop-types';
import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import VideoSeries from '../components/series/video_series';
import { addEditorialLinkClickTrackers } from '../utils/analytics';
import { envSpecificSpotID } from '../utils/env';
import {isEmpty} from 'lodash';

const options = {
  displayName: 'VideoSeriesContainer',

  propTypes: {
    article: PropTypes.object.isRequired,
    series: PropTypes.object.isRequired
  },

  mapStateToProps: (state) => [state, {
    article: state.article,
    series: state.series
  }],

  componentDidMount() {
    addEditorialLinkClickTrackers();
  },

  componentDidUpdate() {
    addEditorialLinkClickTrackers();
  },

  contentAboveModules() {
    if (isEmpty(this.props.article)) {
      return null;
    }

    return (
      <VideoSeries
        adsState={this.props.adsState}
        article={this.props.article}
        show={this.props.series}
        meta_title={this.props.meta_data.meta_title}
        meta_description={this.props.meta_data.meta_description}
        page_type={this.props.analytics.page_type}
        spotID={this.spotID()}
      />
    );
  },

  shouldDisplayInvertedStyles() {
    return true;
  },

  spotID() {
    return envSpecificSpotID(
      this.props.location.hostname,
      this.props.edition_data.config.spotim_id
    );
  }
};

export const VideoSeriesContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
